import {useLocalization} from "./i18n";
import {B2Site} from "./data/client.gen";
import React from "react";

type SiteBookingUnit = B2Site['bookingUnit'];

export function DisplayUnitsCount({unit, count}: { unit: SiteBookingUnit, count: number }) {
	const {t} = useLocalization();
	let counter: string = '';
	switch (unit) {
		case "Days": counter = count > 1 ? t('dates.days') : t('dates.day'); break;
		case "Hours": counter = count > 1 ? t('dates.hours') : t('dates.hour'); break;
	}
	return <span>{count + ' ' + counter}</span>;
}

export function displayBoxesCount(count: number) {
	const {t} = useLocalization();
	return (count > 1 ? t('boxes.plural') : t('boxes.singular'));
}

export function hasSimplifiedLayout(site: B2Site|undefined) {
	if (site == undefined) return false;
	const boxTypesCount = new Set(site.boxes.map(b => b.type)).size;
	return !site.enabledAdvanceBooking && boxTypesCount === 1;
}
